import { ICustomDropdownOption } from 'src/components/custom-multi-select-dropdown';
import { availableModulesList } from '../grant-access.model';

const availableModulesLabels = availableModulesList.map((x) => x.label);
export const changeTypeOfAccessibleModules = (
	accessibleModules: string,
	availableModulesListInput: string[],
): ICustomDropdownOption[] => {
	const data = {
        label: 'All',
        value: -1,
    };
	const convertToArr = accessibleModules ? accessibleModules.split(',') : [];
	let accessibleModuleList: ICustomDropdownOption[] = [];
	if (accessibleModules && convertToArr.length) {
	  	accessibleModuleList = convertToArr.map((x: string) => {
			const list = availableModulesListInput.find(
				(module: string) => availableModulesLabels.indexOf(module) + 1 === Number(x),
			);
			return list
				? {
					label: availableModulesLabels[availableModulesLabels.indexOf(list)],
					value: availableModulesLabels.indexOf(list) + 1,
				}
				: { label: '', value: -1 };
		});
		if (convertToArr.length === availableModulesListInput.length) {
			accessibleModuleList = [data, ...accessibleModuleList];
        }
		return accessibleModuleList;
	}
	return [];
};
